<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Almost Forever</h1>
<h1 class="subtitle">A Spencer-Nyle Co Romance</h1>
<p class="author">Linda Howard</p>
<div class="img_container1">
<img alt="Images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?a1852e8a